/* eslint-disable no-use-before-define */
import React from 'react'

export let MinimalNavigation =  () => <nav className="minimal-navigation">
    <div className="row vertical-offset-xs" style={{
        borderBottom: '1px solid #e4e4e4'
    }}>
    <div className="col-xs-12 vertical-offset-xs">
        <a href="https://etrade.com"><img src="resources/images/logo.svg" alt="etrade" width="150" /></a>
    </div>
    </div>
</nav>
